// Auto-detect which server we're running on from the browser URL.
// This means the SAME build works on web, web1, web2, web3, web4, web5 —
// no manual code change needed before each deployment.
//
// ── DEVELOPMENT OVERRIDE ──────────────────────────────────────────────────
// To load data from a specific server while on localhost, create a file
// called  .env.local  in the project root and add one line:
//
//   REACT_APP_SERVER=web1     ← change to web / web1 / web2 / web3
//
// Delete the line (or set it to "web") to go back to the default.
// .env.local is git-ignored so it won't affect other developers.
// ─────────────────────────────────────────────────────────────────────────

const hostname = typeof window !== "undefined" ? window.location.hostname : "";

// env variable wins (development override), then hostname detection, then default
let api = process.env.REACT_APP_SERVER || "web2";
if (!process.env.REACT_APP_SERVER) {
  if (hostname.includes("web1."))      api = "web1";
  else if (hostname.includes("web2.")) api = "web2";
  else if (hostname.includes("web3.")) api = "web3";
  else if (hostname.includes("web4.")) api = "web4";
  else if (hostname.includes("web5.")) api = "web5";
  else if (hostname.includes("web6.")) api = "web6";
  else if (hostname.includes("web."))  api = "web";
}

let apiUrl;
let apiUrl2;
let webapi;
let apiUrl3;
let genevent;
let genevent2;
let getfolderfiles;
let apiUrl4;
let report;
let web5;
let getimages;
let selectedfolder;
let mailreprt;
let distributor;
let genreprt;
let maxevent;


if (api === "web") {
   apiUrl = "https://web.mybiocalculus.com:3002/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://data.mybiocalculus.com/api/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web.mybiocalculus.com/";
   genevent2 = "https://web.mybiocalculus.com/";
   getfolderfiles = "https://web.mybiocalculus.com/user_records";
   apiUrl4 = "https://web.mybiocalculus.com:3002/";
   report = "https://pdf.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   getimages = "https://find.mybiocalculus.com/assets/dist/user_records/";
   mailreprt = "https://data.mybiocalculus.com/api/";
   selectedfolder = "https://web.mybiocalculus.com:3002/";
   distributor = "https://data.mybiocalculus.com/api/";
}

if (api === "web1") {
   apiUrl = "https://web1.mybiocalculus.com/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://data.mybiocalculus.com/api/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web1.mybiocalculus.com/";
   genevent2 = "https://web1.mybiocalculus.com/";
   getfolderfiles = "https://web1.mybiocalculus.com/assets/dist/user_records";
   apiUrl4 = "https://web1.mybiocalculus.com/";
   report = "https://reportweb.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   getimages = "https://find.mybiocalculus.com/assets/dist/user_records/";
   mailreprt = "https://web2.mybiocalculus.com/";
   selectedfolder = "https://data.mybiocalculus.com/api/";
   distributor = "https://data.mybiocalculus.com/api/";
   genreprt = "https://web1.mybiocalculus.com/api";
   maxevent = "https://web1.mybiocalculus.com/api";
}

if (api === "web2") {
   apiUrl = "https://web2.mybiocalculus.com/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://web.mybiocalculus.com:3002/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web2.mybiocalculus.com/";
   genevent2 = "https://web2.mybiocalculus.com/";
   getfolderfiles = "https://web2.mybiocalculus.com/assets/dist/user_records";
   apiUrl4 = "https://web2.mybiocalculus.com/";
   selectedfolder = "https://data.mybiocalculus.com/api/";
   report = "https://report.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   mailreprt = "https://web2.mybiocalculus.com/";
   distributor = "https://data.mybiocalculus.com/api/";
   genreprt = "https://web2.mybiocalculus.com/api";
}

if (api === "web3") {
   apiUrl = "https://web3.mybiocalculus.com/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://data.mybiocalculus.com/api/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web3.mybiocalculus.com/";
   genevent2 = "https://web3.mybiocalculus.com/";
   getfolderfiles = "https://web3.mybiocalculus.com/assets/dist/user_records";
   apiUrl4 = "https://web3.mybiocalculus.com/";
   report = "https://reportweb3.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   getimages = "https://find.mybiocalculus.com/assets/dist/user_records/";
   mailreprt = "https://web3.mybiocalculus.com/";
   selectedfolder = "https://data.mybiocalculus.com/api/";
   distributor = "https://data.mybiocalculus.com/api/";
   genreprt = "https://web3.mybiocalculus.com/api";
   maxevent = "https://web3.mybiocalculus.com/api";
}

if (api === "web4") {
   apiUrl = "https://web4.mybiocalculus.com/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://data.mybiocalculus.com/api/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web4.mybiocalculus.com/";
   genevent2 = "https://web4.mybiocalculus.com/";
   getfolderfiles = "https://web4.mybiocalculus.com/assets/dist/user_records";
   apiUrl4 = "https://web4.mybiocalculus.com/";
   report = "https://reportweb4.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   getimages = "https://find.mybiocalculus.com/assets/dist/user_records/";
   mailreprt = "https://web4.mybiocalculus.com/";
   selectedfolder = "https://data.mybiocalculus.com/api/";
   distributor = "https://data.mybiocalculus.com/api/";
   genreprt = "https://web4.mybiocalculus.com/api";
}

if (api === "web5") {
   apiUrl = "https://web5.mybiocalculus.com:3002/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://data.mybiocalculus.com/api/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web5.mybiocalculus.com:3002/";
   genevent2 = "https://web5.mybiocalculus.com:3002/";
   getfolderfiles = "https://web5.mybiocalculus.com/assets/dist/user_records";
   apiUrl4 = "https://web5.mybiocalculus.com:3002/";
   report = "https://reportweb5.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   getimages = "https://find.mybiocalculus.com/assets/dist/user_records/";
   mailreprt = "https://web5.mybiocalculus.com:3002/";
   selectedfolder = "https://data.mybiocalculus.com/api/";
   distributor = "https://data.mybiocalculus.com/api/";
   genreprt = "https://web5.mybiocalculus.com:3002/api";
}

if (api === "web6") {
   apiUrl = "https://web6.mybiocalculus.com:3002/";
   apiUrl2 = "https://data.mybiocalculus.com/api/";
   webapi = "https://data.mybiocalculus.com/api/";
   apiUrl3 = "https://find.mybiocalculus.com/";
   genevent = "https://web6.mybiocalculus.com:3002/";
   genevent2 = "https://web6.mybiocalculus.com:3002/";
   getfolderfiles = "https://web6.mybiocalculus.com/assets/dist/user_records";
   apiUrl4 = "https://web6.mybiocalculus.com:3002/";
   report = "https://reportweb6.mybiocalculus.com/";
   web5 = "https://apiUrl.mybiocalculus.com:3002/";
   getimages = "https://find.mybiocalculus.com/assets/dist/user_records/";
   mailreprt = "https://web6.mybiocalculus.com:3002/";
   selectedfolder = "https://data.mybiocalculus.com/api/";
   distributor = "https://data.mybiocalculus.com/api/";
   genreprt = "https://web6.mybiocalculus.com:3002/api";
}

// Telemetry endpoints (/api/telemetry/*) are only deployed on the `web`
// backend right now. Pin the telemetry calls to that host so the dashboard
// works regardless of which front-end host (web1/web2/...) is serving the
// React build. When telemetry routes get deployed everywhere, switch this
// to `apiUrl` so each server hits its own backend.
// Telemetry routes target — pointed at web6 for the testing phase.
// NOTE: web6's backend must have the telemetry router MOUNTED
// (app.use("/api/telemetry", ...) in server.js) or every tab 404s.
const telemetryApi = "https://web6.mybiocalculus.com:3002/";

// Live Monitor (/live-monitor) socket + REST target. The live pipeline lives
// in the `serverapp` process (127.0.0.1:15000), which Apache fronts on the
// BARE web6 domain — `/api` and `/socket.io/` both proxy to :15000. So this
// must be the bare host (NOT :3002, which is a different node process without
// the live routes). Pinned to web6 during the testing phase.
const liveApi = "https://web6.mybiocalculus.com/";

// Account creation (doctor / hospital / patient / customer) must ALWAYS land on
// the central `web` master — never on the per-host backend (web1/web2/web4/web6)
// that happens to serve the dashboard — so new accounts live in one place.
// web's BackendCodes (:3002) serves BOTH /api/androidapi/* (registration) and
// /api/users/AddCustomer, so this single base covers every AddAccounts call.
const accountsApi = "https://web.mybiocalculus.com:3002/";

export { distributor, maxevent, mailreprt, apiUrl, apiUrl2, apiUrl3, genevent, apiUrl4, report, web5, genevent2, getfolderfiles, webapi, selectedfolder, getimages, genreprt, telemetryApi, liveApi, accountsApi };
